// noinspection SpellCheckingInspection

export const citiesList = {
    "adygea": "Республика Адыгея",
    "altai_republic": "Республика Алтай",
    "altai_krai": "Алтайский край",
    "amur": "Амурская область",
    "arkhangelsk": "Архангельская область",
    "astrakhan": "Астраханская область",
    "bashkortostan": "Республика Башкортостан",
    "belgorod": "Белгородская область",
    "bryansk": "Брянская область",
    "buryatia": "Республика Бурятия",
    "chechen": "Чеченская Республика",
    "chelyabinsk": "Челябинская область",
    "chukotka": "Чукотский А.О.",
    "chuvashia": "Чувашская Республика",
    "dagestan": "Республика Дагестан",
    "jewish_ao": "Еврейская Авт. Область",
    "yamalo_nenets": "Ямало-Ненецкий А.О.",
    "yaroslavl": "Ярославская область",
    "ingushetia": "Республика Ингушетия",
    "irkutsk": "Иркутская область",
    "ivanovo": "Ивановская область",
    "kabardino_balkaria": "Кабардино-Балкарская Республика",
    "kaliningrad": "Калининградская область",
    "kalmykia": "Республика Калмыкия",
    "kaluga": "Калужская область",
    "kamchatka": "Камчатский край",
    "karachay_cherkessia": "Карачаево-Черкесская Республика",
    "karelia": "Республика Карелия",
    "kemerovo": "Кемеровская область",
    "kirov": "Кировская область",
    "komi": "Республика Коми",
    "kostroma": "Костромская область",
    "krasnodar": "Краснодарский край",
    "krasnoyarsk": "Красноярский край",
    "crimea": "Республика Крым",
    "kurgan": "Курганская область",
    "kursk": "Курская область",
    "lipetsk": "Липецкая область",
    "magadan": "Магаданская область",
    "mari_el": "Республика Марий Эл",
    "mordovia": "Республика Мордовия",
    "moscow_oblast": "Московская область",
    "moscow_city": "г. Москва",
    "murmansk": "Мурманская область",
    "nenets": "Ненецкий А.О.",
    "nizhny_novgorod": "Нижегородская область",
    "novgorod": "Новгородская область",
    "novosibirsk": "Новосибирская область",
    "omsk": "Омская область",
    "orel": "Орловская область",
    "orenburg": "Оренбургская область",
    "north_ossetia": "Республика Сев.Осетия-Алания",
    "penza": "Пензенская область",
    "perm": "Пермский край",
    "primorsky": "Приморский край",
    "pskov": "Псковская область",
    "ryazan": "Рязанская область",
    "rostov": "Ростовская область",
    "samara": "Самарская область",
    "st_petersburg": "г. Санкт-Петербург и Лен.область",
    "saratov": "Саратовская область",
    "sakha": "Республика Саха (Якутия)",
    "sakhalin": "Сахалинская область",
    "sevastopol": "г. Севастополь",
    "sirius": "Фед. территория Сириус",
    "north_caucasus": "ЦВ СУ Северо-Кавказского Фед. округа",
    "smolensk": "Смоленская область",
    "stavropol": "Ставропольский край",
    "sverdlovsk": "Свердловская область",
    "tambov": "Тамбовская область",
    "tatarstan": "Республика Татарстан",
    "tomsk": "Томская область",
    "tyumen": "Тюменская область",
    "tver": "Тверская область",
    "tula": "Тульская область",
    "tuva": "Республика Тыва",
    "vladimir": "Владимирская область",
    "volgograd": "Волгоградская область",
    "vologda": "Вологодская область",
    "voronezh": "Воронежская область",
    "khabarovsk": "Хабаровский край",
    "khakassia": "Республика Хакасия",
    "khanty_mansi": "Ханты-Мансийский А.О.",
    "udmurtia": "Удмуртская Республика",
    "ulyanovsk": "Ульяновская область",
    "zabaykalsky": "Забайкальский край"
};